(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvela-bewijs"] && !Shopify.designMode) return;
  try {
    
(() => {
  const spelers = document.querySelectorAll('[data-nv-bewijs-video]');
  if (!spelers.length) return;

  // Pas laden en afspelen als de video in beeld komt, en weer pauzeren
  // zodra hij eruit is. Drie video's die meteen starten kost te veel op mobiel.
  const kijker = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting) {
        if (video.preload === 'none') {
          video.preload = 'auto';
          video.load();
        }
        const poging = video.play();
        if (poging) poging.catch(() => {});
      } else {
        video.pause();
      }
    });
  }, { rootMargin: '150px 0px', threshold: 0.25 });

  spelers.forEach((video) => kijker.observe(video));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvela-voorna"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-nv-voorna]').forEach((kader) => {
    const input = kader.querySelector('[data-nv-voorna-input]');
    if (!input) return;

    const zet = () => kader.style.setProperty('--nv-x', input.value + '%');
    input.addEventListener('input', zet);
    zet();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
